export const getPcsUrls = (mobile, desktop) => ({
    mobile: !!mobile ? `${window.MEDIA_DOMAIN}/${mobile?.replace('.', ',0,0,0,0.')}` : "",
    desktop: !!desktop ? `${window.MEDIA_DOMAIN}/${desktop?.replace('.', ',0,0,0,0.')}` : ""
})